module.exports = __webpack_public_path__ + "static/img/客服微信二维码.37aee04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/客服微信二维码.png
// module id = 249
// module chunks = 99